export default settingsConfig;

/** @ngInject */
function settingsConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Konfiguracja początkowa',
    state: 'modules.settings.step1',
    showInMenu: false,
    permissions: ['ALL']
  });

  $stateProvider
    .state('modules.settings', {
      abstract: true,
      url: '/settings',
      data: {
        hideNavbar: true
      },
      resolve: {
        me: SchoolCommonRoomService => SchoolCommonRoomService.getMe(),
        schoolCommonRoom: SchoolCommonRoomService => SchoolCommonRoomService.getCurrentSchoolCommonRoom()
      }
    })
    .state('modules.settings.step1', {
      url: '/step/1',
      data: {
        title: 'Konfiguracja krok 1/6',
        displayName: 'Konfiguracja krok 1/6'
      },
      views: {
        'content@': {
          component: 'stepFirstComponent'
        }
      },
      resolve: {
        assignedClassRooms: ClassRoomService => ClassRoomService.getClassRooms(true),
        employees: EmployeeService => EmployeeService.getSchoolCommonRoomEmployees(0, true),
        unassignedClassRooms: ClassRoomService => ClassRoomService.getUnassignedClassRooms(true),
        unassignedEmployees: EmployeeService => EmployeeService.getUnassignedEmployees(0, true),
        roles: EmployeeService => EmployeeService.getRoles(true)
      }
    })
    .state('modules.settings.step2', {
      url: '/step/2',
      data: {
        title: 'Konfiguracja krok 2/6',
        displayName: 'Konfiguracja krok 2/6'
      },
      views: {
        'content@': {
          component: 'stepSecondComponent'
        }
      }
    })
    .state('modules.settings.step3', {
      url: '/step/3',
      data: {
        title: 'Konfiguracja krok 3/6',
        displayName: 'Konfiguracja krok 3/6'
      },
      views: {
        'content@': {
          component: 'stepThirdComponent'
        }
      }
    })
    .state('modules.settings.step4', {
      url: '/step/4',
      data: {
        title: 'Konfiguracja krok 4/6',
        displayName: 'Konfiguracja krok 4/6'
      },
      views: {
        'content@': {
          component: 'stepFourthComponent'
        }
      }
    })
    .state('modules.settings.step5', {
      url: '/step/5',
      data: {
        title: 'Konfiguracja krok 5/6',
        displayName: 'Konfiguracja krok 5/6'
      },
      views: {
        'content@': {
          component: 'stepFifthComponent'
        }
      },
      resolve: {
        schoolCommonRoom: SchoolCommonRoomService => SchoolCommonRoomService.getCurrentSchoolCommonRoom()
      }
    })
    .state('modules.settings.step6', {
      url: '/step/6',
      data: {
        title: 'Konfiguracja krok 6/6',
        displayName: 'Konfiguracja krok 6/6'
      },
      views: {
        'content@': {
          component: 'stepSixthComponent'
        }
      },
      resolve: {
        activities: ActivityService => ActivityService.get(null, true)
      }
    })
    .state('modules.settings.summary', {
      url: '/summary',
      data: {
        title: 'Konfiguracja - podsumowanie',
        displayName: 'Konfiguracja - podsumowanie'
      },
      views: {
        'content@': {
          component: 'summaryComponent'
        }
      }
    });
}
